import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { RepairGroup } from './repair-group';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class RepairGroupService {

    private api_url = `${environment.ApiUrl}/repairGroup`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<RepairGroup[]>(this.api_url);
    }

    save(repairGroup: RepairGroup) {
        return this.http.post<RepairGroup>(this.api_url, repairGroup, httpOptions);
    }

    update(repairGroup: RepairGroup) {
        return this.http.put<RepairGroup>(this.api_url, repairGroup, httpOptions);
    }

    delete(repairGroup: RepairGroup) {
        const url = `${this.api_url}/${repairGroup.id}`;
        return this.http.delete(url, httpOptions);
    }
}